<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import BirimSecimi from "../FormComponet/BirimSecimiAnaBirim.vue";


export default {
  mixins: [Api, Sabit],
  page: {
    title: "Birim Gösterge Eşleştirme",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    BirimSecimi



  },
  data() {
    return {
      title: this.$t("StrBirimGosterge.Title"),
      items: [
        {
          text: this.$t("StrBirimGosterge.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrBirimGosterge.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrBirimGosterge.Title"),
          active: true,
        },
      ],

      Message: {
        position: "",
        icon: "",
        title: "",
        showConfirmButton: false,
        timer: 1500,
      },
      counter: 0,
      UstDonemId: null,
      secilen_birim: "",
      secilen_donem: "",
      ComboboxDonemler: [],
      ComboboxTablolar: [],
      ComboboxBirimler: [],
      ComboboxGostergeler: [],
      YuklenenTablolar: [],
      TabloDetaylar: [],
      GostergeBirimlerData:[],
      TabloDetay:{},
      Secilen: null,
      sorgula:0,
      DetayId:"",
      DonemId:"",
      BirimId:"",
      tumunusec:false,
      TableData:[],
      SecilenGostergeler:[],
      RapordaGorunmeyecek:[],
      VerigirisiYapilmayacak:[],
      SecilenBirimler:[],
      RapordaGorunmeyecekBirim:[],
      VerigirisiYapilmayacakBirim:[],
      Filter: {
        DonemId: "",
        GdonemId: "",
        TabloId: "",
        GostergeId:"",
        BirimId: null,
      },
      siralama:"&Asc=SiraNo",
      birim_siralama:"&Asc=BirimAdi",
      birimgostergeData: {
          "Id": "",
          "Deleted": false,
          "Birimid": "",
          "Donemid": "",
          "Tabloid": "",
          "Gostergeids": [],
          "BirimTipiId": ""
      },
      gostergebirimData: {
          "Donemid": "",
          "Tabloid": "",
          "Birimid": "",
          "Birimids": []
      }
    };
  },

  methods: {
    /* ANCHOR Combobox yükleme metodları */
 

    Secilmis_Idler(secilmis) {
      if (secilmis != null) {
         // this.tablo_combo_yukle(secilmis);
          this.secilen_birim = secilmis;

      }
    },


    tablo_combo_yukle(ust_id) {

      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
       this.SecilenGostergeler=[];
       this.SecilenBirimler=[];

      this.UstDonemId = ust_id;

      let Filter = "";
      this.ComboboxTablolar = [];
      let tum_tablolar=[];
      let tablo=[];

      Filter = "&DonemId=" + ust_id+"&Aktif=true&Asc=SiraNo";
      this.ActionsFilterGet({Service:"StrPerfTablo", Page:Page, Filter:Filter}).then((res) => {
        tum_tablolar = res.Data;

          for (var s = 0; s < tum_tablolar.length; s++) {

              tablo.push(tum_tablolar[s]);
        
          }

        this.ComboboxTablolar = tablo;

  
      });


    },

    Get(tabloid) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

      let sorgu = "&Tip=47";
      let GostergeTipiId="";
      
      this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
          for(var i=0; i<res.Data.length; i++)
          {   
              if(res.Data[i].Kod==1) { 

                GostergeTipiId=res.Data[i].Id;       

              } 
             
          }
      

      if(this.secilen_birim!=null && this.secilen_birim!=""){

      let Filter = "&Tabloids=" +tabloid+"&GostergeTipiId="+GostergeTipiId+"&Aktif=true";
        if(this.siralama!=null && this.siralama!=""){
        Filter=Filter+this.siralama;
      }

    let Filter2 = "&Birimid="+this.secilen_birim+"&Donemid="+this.Filter.DonemId+"&Tabloid=" +tabloid;

    this.ActionsFilterGet({ Service: "StrBirimGosterge", Page: Page, Filter: Filter2 }).then((res) => {
        
            if(res.Data.length>0){
                this.AddEdit ="Update";
               
                this.birimgostergeData = res.Data[0];
                
                this.SecilenGostergeler=this.birimgostergeData.Gostergeids;
                this.RapordaGorunmeyecek=this.birimgostergeData.Raporlardagorunmesinids;
                this.VerigirisiYapilmayacak=this.birimgostergeData.Verigirisiyapilmasinids;

                  this.ActionsFilterGet({ Service: "StrPerfTablolarDetay", Page: Page, Filter: Filter }).then((res) => {
                    this.TableData = res.Data;

                        for (var i=0;  i<this.TableData.length;i++){

                            if(this.SecilenGostergeler!=null){
                                  var sonuc = this.SecilenGostergeler.indexOf( this.TableData[i].Id);
                                  if(sonuc>=0){
                                      this.TableData[i].checked=true;
                                  } else{
                                        this.TableData[i].checked=false;
                                  }
                            }


                            if(this.RapordaGorunmeyecek!=null){
                                  sonuc = this.RapordaGorunmeyecek.indexOf( this.TableData[i].Id);
                                  if(sonuc>=0){
                                      this.TableData[i].Raporlardagorunmesin=true;
                                  } else{
                                        this.TableData[i].Raporlardagorunmesin=false;
                                  }
                            }

                            if(this.VerigirisiYapilmayacak!=null){
                                  sonuc = this.VerigirisiYapilmayacak.indexOf( this.TableData[i].Id);
                                  if(sonuc>=0){
                                      this.TableData[i].Verigirisiyapilmasin=true;
                                  } else{
                                        this.TableData[i].Verigirisiyapilmasin=false;
                                  }
                            }

                          
                        }

                           if (this.SecilenGostergeler.length==this.TableData.length){this.tumunusec=true;}
                  });

          
            } else {
            
              this.AddEdit = "Add"

               this.ActionsFilterGet({ Service: "StrPerfTablolarDetay", Page: Page, Filter: Filter }).then((res) => {
                    this.TableData = res.Data;

                  });
            }


    });



      }

    });

    },

    kaydet(){
      this.birimgostergeData.Gostergeids=this.SecilenGostergeler;
      this.birimgostergeData.Raporlardagorunmesinids=this.RapordaGorunmeyecek;
      this.birimgostergeData.Verigirisiyapilmasinids=this.VerigirisiYapilmayacak;
      this.birimgostergeData.Birimid=this.secilen_birim;
      this.birimgostergeData.Donemid=this.Filter.DonemId;
      this.birimgostergeData.Tabloid=this.Filter.TabloId;
      this.birimgostergeData.Modul=1;

       if (this.AddEdit == "Add") { 
           this.$delete(this.birimgostergeData, "Id");
            this.$delete(this.birimgostergeData, "BirimTipiId");
              this.Post("StrBirimGosterge", this.birimgostergeData).then((res) => {
                  if (res) {

                      this.$emit("TableUpdate");
                     // this.Get(this.Filter.TabloId);
                  }
              });
        } else {
         this.$delete(this.birimgostergeData, "BirimTipiId");
         this.Update("StrBirimGosterge", this.birimgostergeData).then((res) => {
              if (res) {
                   this.$emit("TableUpdate");
                   //this.Get(this.Filter.TabloId);
                
              }
         });

        }


    },

    tumunu_sec(){
      this.SecilenGostergeler=[];
      if (this.tumunusec==false){
          for ( var i=0; i<this.TableData.length; i++){
              this.TableData[i].checked=true;
          }
          for ( i=0; i<this.TableData.length; i++){
             this.SecilenGostergeler.push(this.TableData[i].Id);    
          }

      } else {
          for ( i=0; i<this.TableData.length; i++){
            this.TableData[i].checked=false;  
          }
           this.SecilenGostergeler=[];
           this.tumunusec=false;
      }
    

    },

    kayit_sec(gosterge_id,index,islem){

        if (islem==1){
            var varmi=this.SecilenGostergeler.indexOf(gosterge_id);
      
            if (varmi<0){
                this.SecilenGostergeler.push(gosterge_id);
                this.TableData[index].checked=true;
            } else {
                this.SecilenGostergeler.splice(varmi,1);
                this.TableData[index].checked=false;
              
                this.tumunusec=false;
            }

            if (this.SecilenGostergeler.length==0){this.tumunusec=false;}
            if (this.SecilenGostergeler.length==this.TableData.length){this.tumunusec=true;}
        }

        if (islem==2){
             varmi=this.RapordaGorunmeyecek.indexOf(gosterge_id);
      
            if (varmi<0){
                this.RapordaGorunmeyecek.push(gosterge_id);
                this.TableData[index].Raporlardagorunmesin=true;
            } else {
                this.RapordaGorunmeyecek.splice(varmi,1);
                this.TableData[index].Raporlardagorunmesin=false;            
            }
     
        }

        if (islem==3){
             varmi=this.VerigirisiYapilmayacak.indexOf(gosterge_id);
      
            if (varmi<0){
                this.VerigirisiYapilmayacak.push(gosterge_id);
                this.TableData[index].Verigirisiyapilmasin=true;
            } else {
                this.VerigirisiYapilmayacak.splice(varmi,1);
                this.TableData[index].Verigirisiyapilmasin=false;            
            }
     
        }

    },

    donem_yukle(){
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
     this.SecilenGostergeler=[];
     this.SecilenBirimler=[];


     let sorgu = "&Tip=1561";
          let Tip=[];
            
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
              console.log(res)
                for(var i=0; i<res.Data.length; i++)
                {   
                    if(res.Data[i].Kod==1 || res.Data[i].Kod==2 ) { 

                        Tip.push(res.Data[i].Id);       

                    } 
                   
                }

                let altsorgu="&UstIdDoluMu=false&Approval=true";

                let tipler="";

                for (var s=0; s<Tip.length; s++){

                    tipler=tipler+"&TipId="+Tip[s];

                }

                altsorgu=altsorgu+tipler;

             

                this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
                for (var i = 0; i < res.Data.length; i++) {
            
                  this.ComboboxDonemler.push(res.Data[i]);
                  
                }
              });
         
            });


/*

       this.ActionsGet({"Service":"StrPerfDonem", "Page":Page}).then((res) => {
      let gelen_veri = res.Data;
      this.ComboboxDonemler=[];

      for (var i = 0; i < gelen_veri.length; i++) {
        if (gelen_veri[i].UstId == "" || gelen_veri[i].UstId == null) {
          this.ComboboxDonemler.push(gelen_veri[i]);
        }
      }
    });

*/



    },
    gosterge_yukle(tabloid){
       this.SecilenGostergeler=[];
      
        let Page = {
          PageNumber: "1",
          PageSize: "99999",
        };

        this.ComboboxGostergeler=[];

        let Filter = "&Tabloids=" +tabloid+"&GostergeTipiId=65afb19e-fbdf-4435-babd-d0c28597f6fd&Aktif=true";
        
            if(this.siralama!=null && this.siralama!=""){
            Filter=Filter+this.siralama;
            }

        this.ActionsFilterGet({ Service: "StrPerfTablolarDetay", Page: Page, Filter: Filter }).then((res) => {
                this.ComboboxGostergeler = res.Data;
        });

    },

    Get_Gosterge_Birimler(gosterge_id){

     let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };


      this.birimgostergeData=[];
      this.GostergeBirimlerData=[];
  
    let Filter2 = "&Gostergeid="+gosterge_id+"&Donemid="+this.Filter.DonemId;

    this.ActionsFilterGet({ Service: "StrBirimGosterge", Page: Page, Filter: Filter2 }).then((res) => {
        
            if(res.Data.length>0){
             

                this.birimgostergeData = res.Data;
                this.SecilenBirimler=[];

                for(var s=0; s<this.birimgostergeData.length;s++){
                
                    this.SecilenBirimler.push(this.birimgostergeData[s].Birimid);

                    if (this.birimgostergeData[s].Raporlardagorunmesinids!=null && this.birimgostergeData[s].Raporlardagorunmesinids.length>0){
                        var sonuc = this.birimgostergeData[s].Raporlardagorunmesinids.indexOf(gosterge_id);
                        if(sonuc>=0){
                            this.RapordaGorunmeyecekBirim.push(this.birimgostergeData[s].Birimid);
                        }
                    }

                    if (this.birimgostergeData[s].Verigirisiyapilmasinids!=null && this.birimgostergeData[s].Verigirisiyapilmasinids.length>0){
                        sonuc = this.birimgostergeData[s].Verigirisiyapilmasinids.indexOf(gosterge_id);
                        if(sonuc>=0){
                            this.VerigirisiYapilmayacakBirim.push(this.birimgostergeData[s].Birimid);
                        }
                    }


                }

                      this.ActionsFilterGet({"Service":"OBirim/GetTreeByAnaBirim", "Page":Page, Filter: "&GetProgramlarVeBolumler=false"}).then((res2) => {

                           this.GostergeBirimlerData = res2.Data;                      

                           for (var i=0;  i<this.GostergeBirimlerData.length;i++){

                             for (var s=0; s<this.GostergeBirimlerData[i].children.length; s++){
                              
                                  var sonuc = this.SecilenBirimler.indexOf( this.GostergeBirimlerData[i].children[s].id);
                                  if(sonuc>=0){
                                                    
                                        this.GostergeBirimlerData[i].children[s].checked=true;
                                      
                                  } else{
                                        this.GostergeBirimlerData[i].children[s].checked=false;
                                  }

                                  sonuc = this.RapordaGorunmeyecekBirim.indexOf( this.GostergeBirimlerData[i].children[s].id);
                                  if(sonuc>=0){
                                                    
                                        this.GostergeBirimlerData[i].children[s].Raporlardagorunmesin=true;
                                      
                                  } else{
                                        this.GostergeBirimlerData[i].children[s].Raporlardagorunmesin=false;
                                  }

                                  sonuc = this.VerigirisiYapilmayacakBirim.indexOf( this.GostergeBirimlerData[i].children[s].id);
                                  if(sonuc>=0){
                                                    
                                        this.GostergeBirimlerData[i].children[s].Verigirisiyapilmasin=true;
                                      
                                  } else{
                                        this.GostergeBirimlerData[i].children[s].Verigirisiyapilmasin=false;
                                  }

                            }

                           }

                      });
            
          
            } else {
              
               this.ActionsFilterGet({"Service":"OBirim/GetTreeByAnaBirim", "Page":Page, Filter: "&GetProgramlarVeBolumler=false"}).then((res2) => {

                           this.GostergeBirimlerData = res2.Data;

                           for (var i=0;  i<this.GostergeBirimlerData.length;i++){

                                for (var s=0; s<this.GostergeBirimlerData[i].children.length; s++){
                                  
                                     this.GostergeBirimlerData[i].children[s].checked=false;
                                     this.GostergeBirimlerData[i].children[s].Verigirisiyapilmasin=false;
                                     this.GostergeBirimlerData[i].children[s].Raporlardagorunmesin=false;
                                  
                                }

                           }

                  });
            }

    });

    },

    kayit_sec_birim(birim_id,index,altindex,islem){

      if (islem==1) {

        var varmi=this.SecilenBirimler.indexOf(birim_id);
  
        if (varmi<0){
            this.SecilenBirimler.push(birim_id);
             this.GostergeBirimlerData[index].children[altindex].checked=true;
            
        } else {
            this.SecilenBirimler.splice(varmi,1);       
            this.GostergeBirimlerData[index].children[altindex].checked=false;
      
        }
      }

      if (islem==2) {

         varmi=this.RapordaGorunmeyecekBirim.indexOf(birim_id);
  
        if (varmi<0){
            this.RapordaGorunmeyecekBirim.push(birim_id);
             this.GostergeBirimlerData[index].children[altindex].Raporlardagorunmesin=true;
            
        } else {
            this.RapordaGorunmeyecekBirim.splice(varmi,1);       
            this.GostergeBirimlerData[index].children[altindex].Raporlardagorunmesin=false;
      
        }
      }

      if (islem==3) {

         varmi=this.VerigirisiYapilmayacakBirim.indexOf(birim_id);
  
        if (varmi<0){
            this.VerigirisiYapilmayacakBirim.push(birim_id);
             this.GostergeBirimlerData[index].children[altindex].Verigirisiyapilmasin=true;
            
        } else {
            this.VerigirisiYapilmayacakBirim.splice(varmi,1);       
            this.GostergeBirimlerData[index].children[altindex].Verigirisiyapilmasin=false;
      
        }
      }

    },

    tumunu_sec_birim(index){

      if (this.GostergeBirimlerData[index].checked==false || this.GostergeBirimlerData[index].checked==null ){

          for ( var i=0; i<this.GostergeBirimlerData[index].children.length; i++){

              this.GostergeBirimlerData[index].children[i].checked=true;

               var varmi=this.SecilenBirimler.indexOf(this.GostergeBirimlerData[index].children[i].id);

               if (varmi<0){
               this.SecilenBirimler.push(this.GostergeBirimlerData[index].children[i].id); 
               }
          }


      } else {
       
          for ( i=0; i<this.GostergeBirimlerData[index].children.length; i++){

              this.GostergeBirimlerData[index].children[i].checked=false;  

                varmi=this.SecilenBirimler.indexOf(this.GostergeBirimlerData[index].children[i].id);
          
                if (varmi>=0){

                     this.SecilenBirimler.splice(varmi,1);
                    
                } 

             
          }

     
      }
    

    },

    kaydet_birim(){
      this.gostergebirimData= {
          "Donemid": "",
          "Tabloid": "",
          "GostergeId": "",
          "Birimids": []
      }
            this.gostergebirimData.Donemid=this.Filter.DonemId;
            this.gostergebirimData.Tabloid=this.Filter.TabloId;
            this.gostergebirimData.GostergeId=this.Filter.GostergeId;
            this.gostergebirimData.Modul=1;

           

              for (var i=0;i<this.GostergeBirimlerData.length; i++){

                 console.log(this.GostergeBirimlerData[i].children.length)

                  for(var s=0;s<this.GostergeBirimlerData[i].children.length; s++){

                      let birim={"BirimId":this.GostergeBirimlerData[i].children[s].id,
                      "secili":this.GostergeBirimlerData[i].children[s].checked,
                      "Raporlardagorunmesin":this.GostergeBirimlerData[i].children[s].Raporlardagorunmesin,
                      "Verigirisiyapilmasin":this.GostergeBirimlerData[i].children[s].Verigirisiyapilmasin
                      };
                      this.gostergebirimData.Birimids.push(birim);    

                  }

              }

              console.log(JSON.stringify(this.gostergebirimData))

              this.Post("StrBirimGosterge/UpdateByToplu", this.gostergebirimData).then((res) => {
                  if (res) {
               
                     // this.Get(this.Filter.TabloId);
                     this.Get_Gosterge_Birimler(this.Filter.GostergeId)

                  }
              });




    },


  },

  created() {

    this.donem_yukle();
    this.SecilenGostergeler=[];


  },


};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />


  <b-tabs content-class="p-3 text-muted">
        <b-tab active class="border-0">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <country-flag country="tr" size="small" />Birim Gösterge Eşleştirme</span
            >
          </template>

            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-5">

                        <b-form-group
                          class="mb-2"
                          id="donemler"
                          label=""
                          label-for="text"
                        >
                          <select
                            v-model="Filter.DonemId"
                            @change="tablo_combo_yukle(Filter.DonemId)"
                            class="form-select"
                            type="text"
                          >
                            <option value=""
                              >{{$t('StrGostergeGirisi.Filtreleme.UstId')}}</option
                            >
                            <option
                              v-for="DonemVerileri in ComboboxDonemler"
                              :key="DonemVerileri.Id"
                              :value="DonemVerileri.Id"
                            >
                            {{ DonemVerileri.Aciklama }}
                            </option></select
                          >
                        </b-form-group>

                                              
                        <b-form-group
                          class="mb-2"
                          id="gdonemler"
                          label=""
                          label-for="text"
                        >
                          <select
                            v-model="Filter.TabloId"
                            @change="Get(Filter.TabloId),gosterge_yukle(Filter.TabloId)"
                            class="form-select"
                            type="text"
                          >
                            <option value="">{{this.$t('StrGostergeGirisi.Filtreleme.TabloId')}}</option>
                            <option
                              v-for="Tablolar in ComboboxTablolar"
                              :key="Tablolar.Id"
                              :value="Tablolar.Id"
                            >
                          {{ Tablolar.Adi }} 
                            </option></select
                          >
                        </b-form-group>

                         <BirimSecimi
                          :title="''"
                          :title_class="'mb-3'"
                          :closeOnSelect="true"
                          :sutun="'0'"
                          :multiple="false"
                          :YetkiKontrol="0"
                          :personel_id="null"
                          :BirimTipId="null"
                          @Secilmis_Idler="Secilmis_Idler($event),Get(Filter.TabloId)"
                        />

              
                      </div>
        

                    </div>
                  </div>
                </div>
              </div>



            </div>

            
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-body">


            <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                    
                  <th width="7%" scope="col">{{ $t("StrBirimGosterge.Table.SiraNo") }}
                  <i style="margin-left:10px" v-if="siralama!='&Asc=SiraNo'" @click="siralama='&Asc=SiraNo', Get(Filter.TabloId)" class="bx bx-sort-a-z fa-xl"></i>
                  <i style="margin-left:10px" v-if="siralama=='&Asc=SiraNo'" @click="siralama='&Desc=SiraNo', Get(Filter.TabloId)" class="bx bx-sort-z-a  fa-xl"></i>
                  </th>
                      <th width="60%" rowspan="2">
                        {{$t('StrBirimGosterge.Table.Gostergesi')}}
                        <i style="margin-left:10px" v-if="siralama!='&Asc=Gostergesi'" @click="siralama='&Asc=Gostergesi', Get(Filter.TabloId)" class="bx bx-sort-a-z fa-xl"></i>
                  <i style="margin-left:10px" v-if="siralama=='&Asc=Gostergesi'" @click="siralama='&Desc=Gostergesi', Get(Filter.TabloId)" class="bx bx-sort-z-a  fa-xl"></i>
                
                      </th>
                      <th>{{$t('StrBirimGosterge.Table.Raporlardagorunmesin')}}</th>
                      <th>{{$t('StrBirimGosterge.Table.Verigirisiyapilmasin')}}</th>
                      <th> <input type="checkbox" 
                      @click="tumunu_sec()"
                      v-model="tumunusec"
                      class="form-check-input" 
                      value="accepted" id="__BVID__362"></th>

                    </tr>
                    <tr></tr>
                  </thead>
                  <tbody>
                    <tr v-for="(Data,index) in TableData" :key="index">
                  

                        <th scope="row">{{ Data.SiraNo }}</th>

                      <th scope="row">{{ Data.Gostergesi }}</th>

                      <th> 
              
                      <input type="checkbox" 
                      @click="kayit_sec(Data.Id,index,2)"
                      v-model="Data.Raporlardagorunmesin"
                      class="form-check-input" 
                      value="accepted" id="__BVID__362">
                      </th>
                      <th> 
              
                      <input type="checkbox" 
                      @click="kayit_sec(Data.Id,index,3)"
                      v-model="Data.Verigirisiyapilmasin"
                      class="form-check-input" 
                      value="accepted" id="__BVID__362">
                      </th>
      
                  
                        <th> 
              
                      <input type="checkbox" 
                      @click="kayit_sec(Data.Id,index,1)"
                      v-model="Data.checked"
                      class="form-check-input" 
                      value="accepted" id="__BVID__362">
                      </th>
                      
                    
                    </tr>
                  </tbody>
                </table>
              </div> 
              <br>

              <button class="btn btn-primary" @click="kaydet()" type="submit" >Kaydet</button> 



                  </div>
                </div>
              </div>
            </div>

        </b-tab>

        <!--  ANCHOR İkinci Sekmek Başlangıcı  -------------->

        <b-tab  class="border-0">

          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <country-flag country="tr" size="small" />Gösterge Birim Eşleştirme</span
            >
          </template>


      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-5">

                  <b-form-group
                    class="mb-2"
                    id="donemler"
                    label=""
                    label-for="text"
                  >
                    <select
                      v-model="Filter.DonemId"
                      @change="tablo_combo_yukle(Filter.DonemId)"
                      class="form-select"
                      type="text"
                    >
                      <option value=""
                        >{{$t('StrBirimGosterge.Filtreleme.DonemId')}}</option
                      >
                      <option
                        v-for="DonemVerileri in ComboboxDonemler"
                        :key="DonemVerileri.Id"
                        :value="DonemVerileri.Id"
                      >
                       {{ DonemVerileri.Aciklama }}
                      </option></select
                    >
                  </b-form-group>

  
                  <b-form-group
                    class="mb-2"
                    id="gdonemler"
                    label=""
                    label-for="text"
                  >
                    <select
                      v-model="Filter.TabloId"
                      @change="gosterge_yukle(Filter.TabloId)"
                      class="form-select"
                      type="text"
                    >
                      <option value="">{{this.$t('StrBirimGosterge.Filtreleme.TabloId')}}</option>
                      <option
                        v-for="Tablolar in ComboboxTablolar"
                        :key="Tablolar.Id"
                        :value="Tablolar.Id"
                      >
                    {{ Tablolar.Adi }} 
                      </option></select
                    >
                  </b-form-group>


                  <b-form-group
                    class="mb-2"
                    id="gdonemler"
                    label=""
                    label-for="text"
                  >
                    <select
                      v-model="Filter.GostergeId"
                      @change="Get_Gosterge_Birimler(Filter.GostergeId)"
                      class="form-select"
                      type="text"
                    >
                      <option value="">{{this.$t('StrBirimGosterge.Filtreleme.GostergeId')}}</option>
                      <option
                        v-for="Gostergeler in ComboboxGostergeler"
                        :key="Gostergeler.Id"
                        :value="Gostergeler.Id"
                      >
                    {{ Gostergeler.Gostergesi }} 
                      </option></select
                    >
                  </b-form-group>

        
                </div>
   

              </div>
            </div>
          </div>
        </div>



      </div>

      
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
            

<div class="table-responsive">
          <table v-for="(Data,index) in GostergeBirimlerData" :key="index" class="table mb-0">
            <thead   class="table-light">
              <tr>
               
                 <th style="width:20px" scope="row" class="custom-accordion">
                      <a class="text-body fw-medium py-1 d-flex align-items-center" data-toggle="collapse" 
                      v-b-toggle="'CollapseAltTablo' + Data.id" role="button" aria-expanded="false" 
                      aria-controls="categories-collapse">
                        <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
                      </a>
                    </th>
                
                <th>{{Data.label}}</th>
                
              </tr>
            </thead>
             <tbody>
              <tr>
                <td></td>
                <td>
                  <b-collapse class="collapse show" :id="'CollapseAltTablo' + Data.id">

                  <div class="table-responsive">
                    <table class="table mb-0">
                      <thead class="table-light">
                        <tr>
                        
                      <th  width="7%" scope="col">{{ $t("StrBirimGosterge.TableGostergeBirimler.Sira") }}
                      <i style="margin-left:10px" v-if="siralama!='&Asc=SiraNo'" @click="siralama='&Asc=SiraNo', Get(Filter.TabloId)" class="bx bx-sort-a-z fa-xl"></i>
                      <i style="margin-left:10px" v-if="siralama=='&Asc=SiraNo'" @click="siralama='&Desc=SiraNo', Get(Filter.TabloId)" class="bx bx-sort-z-a  fa-xl"></i>
                      </th>
                          <th width="60%" rowspan="2">
                            {{$t('StrBirimGosterge.TableGostergeBirimler.BirimAdi')}}
                            <i style="margin-left:10px" v-if="siralama!='&Asc=Gostergesi'" @click="siralama='&Asc=Gostergesi', Get(Filter.TabloId)" class="bx bx-sort-a-z fa-xl"></i>
                            <i style="margin-left:10px" v-if="siralama=='&Asc=Gostergesi'" @click="siralama='&Desc=Gostergesi', Get(Filter.TabloId)" class="bx bx-sort-z-a  fa-xl"></i>
                    
                          </th>
                          <th>{{$t('StrBirimGosterge.Table.Raporlardagorunmesin')}}</th>
                          <th>{{$t('StrBirimGosterge.Table.Verigirisiyapilmasin')}}</th>
                          <th> <input type="checkbox" 
                          @click="tumunu_sec_birim(index)"
                          v-model="Data.checked"
                          class="form-check-input" 
                          value="accepted" id="__BVID__362"></th>

                        </tr>
                        <tr></tr>
                      </thead>
                      <tbody>
                        <tr v-for="(child,altindex) in Data.children" :key="altindex">
                      

                            <th scope="row">{{ altindex+1 }}</th>

                          <th scope="row">{{ child.label }}</th>



                      <th>            
                      <input type="checkbox" 
                      @click="kayit_sec_birim(child.id,index,altindex,2)"
                      v-model="child.Raporlardagorunmesin"
                      class="form-check-input" 
                      value="accepted" id="__BVID__362">
                      </th>

                      <th> 
                      <input type="checkbox" 
                      @click="kayit_sec_birim(child.id,index,altindex,3)"
                      v-model="child.Verigirisiyapilmasin"
                      class="form-check-input" 
                      value="accepted" id="__BVID__362">
                      </th>
  
                      
                      <th> 
                      <input type="checkbox" 
                      @click="kayit_sec_birim(child.id,index,altindex,1)"
                      v-model="child.checked"
                      class="form-check-input" 
                      :id="altindex">
                      </th>
                          
                        
                        </tr>
                      </tbody>
                    </table>
                  </div> 
                  </b-collapse>
                </td>

              </tr>
           </tbody>
        </table>
        </div>
        <br>

        <button class="btn btn-primary" @click="kaydet_birim()" type="submit" >Kaydet</button> 



            </div>
          </div>
        </div>
      </div>

        </b-tab>



      </b-tabs>

    



    </Layout>
  </Loader>
</template>
